import TableFormatterNumber from '../TableFormatterNumber';
var TableFormatterCurrency = TableFormatterNumber.bind(null, {
  format: 'currency_¥'
});
export default TableFormatterCurrency;